export default function LoginTimer({ minutes, seconds }) {
	const arr = [];
	arr.push(minutes < 10 ? `0${minutes}` : minutes);
	arr.push(seconds < 10 ? `0${seconds}` : seconds);

	return <span>{arr.join(':')}</span>;
}
